

export class GpsDeviceStatusInput implements IGpsDeviceStatusInput {
    /** The auto-generated id of the gps device master */
    gpsDeviceId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IGpsDeviceStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gpsDeviceId = _data["gpsDeviceId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GpsDeviceStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new GpsDeviceStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gpsDeviceId"] = this.gpsDeviceId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGpsDeviceStatusInput {
    /** The auto-generated id of the gps device master */
    gpsDeviceId: number;
    /** The updated status */
    status: number;
}

